const gender = {
  Male: 1,
  Female: 2,
}

export default gender;